export default __webpack_public_path__ + "static/media/menu.fe4841b5.svg";